import { cn } from '@/utils/cn'

interface SkeletonProps {
  className?: string
}

export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-white/[0.08]',
        className
      )}
    />
  )
}

export function SkeletonText({ className }: SkeletonProps) {
  return <Skeleton className={cn('h-4 w-20', className)} />
}

export function SkeletonCircle({ className }: SkeletonProps) {
  return <Skeleton className={cn('size-10 rounded-full', className)} />
}
